import { render, staticRenderFns } from "./smartReportCard.vue?vue&type=template&id=ad0795a6&scoped=true&"
import script from "./smartReportCard.vue?vue&type=script&lang=js&"
export * from "./smartReportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0795a6",
  null
  
)

export default component.exports